<template>
  <v-container fluid class="full-height">
    <router-link
      v-if="showBackLink"
      class="subtitle-1 grey-navy--text font-weight-bold text-decoration-none"
      :to="backLink"
    >
      <v-icon small class="pb-1"> keyboard_backspace </v-icon> Back
    </router-link>
    <v-row v-if="loading">
      <v-col cols="12" align="center" justify="center">
        <v-row align="center" justify="center">
          <v-text-field color="success" loading disabled></v-text-field>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="8" xl="9">
        <v-row class="mx-2">
          <v-card>
            <v-card-title>
              Check-in history for
              <a class="grey-navy--text font-weight-bold pl-2" :href="`/clients/${userId}`">
                {{ clientName }}
              </a>
            </v-card-title>
            <v-card-subtitle>
              Filter assessments by:
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="4" class="py-0">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search.startDate"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        label="Assessments from"
                        prepend-icon="mdi-calendar"
                      />
                    </template>
                    <v-date-picker v-model="search.startDate"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search.endDate"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        label="Assessments before"
                        prepend-icon="mdi-calendar"
                      />
                    </template>
                    <v-date-picker v-model="search.endDate"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-select v-model="search.type" label="Check-in type" required :items="typeOptions"> </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="hasSearch" @click="resetFilter"> Reset Filters </v-btn>
              <v-spacer />
              <v-btn
                class="mb-2"
                color="secondary"
                v-if="userCheckIns.length > 0"
                @click="modals.showSummary = !modals.showSummary"
              >
                {{ modals.showSummary ? "Hide" : "Show" }} summary
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-row>

        <div v-if="display.goals" class="mt-6 scroll-panel">
          <assessment-list :userCheckIns="userCheckIns" :userId="userId" />
        </div>
      </v-col>

      <v-dialog v-model="modals.showSummary">
        <v-card class="pa-2">
          <assessment-summary :orderedAssessments="userCheckIns" />
        </v-card>
      </v-dialog>

      <v-col cols="4" xl="3" align="right" justify="end" class="d-flex flex-column full-height pt-0">
        <v-btn color="secondary" @click="showGoals()"> {{ display.goals ? "Hide" : "Show" }} Goals</v-btn>
        <goals v-if="display.goals" :userId="userId" class="mt-2 full-height" />
      </v-col>

      <v-col v-if="!display.goals" :cols="mainCols" class="overflow-auto">
        <assessment-list :userCheckIns="userCheckIns" :userId="userId" />
      </v-col>
    </v-row>
    <div>
      <EditAssessmentForm ref="editAssessment" :close="(editActive = false)"></EditAssessmentForm>
    </div>
  </v-container>
</template>

<script>
import { CLIENT_ASSESSMENTS_QUERY } from "@/constants/graphql/assessments/assessment";
import EditAssessmentForm from "@/components/assessment/forms/EditAssessmentForm";
import Goals from "./goals/Goals";
import AssessmentSummary from "@/components/client/blocks/progress/assessments/AssessmentSummary";
import AssessmentList from "@/components/client/blocks/progress/assessments/AssessmentList";

export default {
  name: "Assessments",
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
    coachId: {
      type: [String, Number],
      required: false,
    },
    showBackLink: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    EditAssessmentForm,
    Goals,
    AssessmentSummary,
    AssessmentList,
  },
  data() {
    return {
      loading: true,
      clientName: null,
      editActive: false,
      userCheckIns: [],
      assessment: {},
      menu1: false,
      menu2: false,
      modals: {
        showSummary: false,
      },
      typeOptions: [
        { value: null, text: "None" },
        { value: "COACHING", text: "Coaching check-in" },
        { value: "USER", text: "User generated check-in" },
      ],
      search: {
        startDate: null,
        endDate: null,
        type: null,
      },
      formKey: 0,
      mainCols: "12",
      display: {
        goals: false,
      },
    };
  },
  created() {
    // if query string is goals=1, then this.display.goals = true
    if (this.$route.query.goals) {
      this.display.goals = true;
    }
  },

  computed: {
    hasSearch() {
      let isSearching = false;
      for (var key in this.search) {
        if (this.search[key] != null) {
          isSearching = true;
          break;
        }
      }
      return isSearching;
    },
    backLink() {
      if (this.coachId) {
        return `/client-profile/${this.coachId}/${this.userId}/`;
      } else {
        return `/client-profile/${this.userId}/`;
      }
    },
  },
  methods: {
    resetFilter() {
      this.search = {
        startDate: null,
        endDate: null,
        type: null,
      };
    },
    showGoals() {
      let xlAndUp = this.$vuetify.breakpoint.xlAndUp;
      this.mainCols = this.display.goals ? "12" : xlAndUp ? "9" : "8";
      this.display.goals = !this.display.goals;
    },
  },
  apollo: {
    userCheckIns: {
      query: CLIENT_ASSESSMENTS_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        let filter = {
          userId: encoded_json_payload,
          decodedId: this.userId,
        };

        if (this.search.startDate) {
          filter.startDate = this.search.startDate;
        }
        if (this.search.endDate) {
          filter.endDate = this.search.endDate;
        }
        if (this.search.type) {
          filter.type = this.search.type;
        }
        return filter;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          this.clientName = `${response.data.client.firstName} ${response.data.client.lastName}`;
        }
      },
      update(data) {
        data.userCheckIns.edges.forEach((checkin) => {
          checkin.node.oneMileTime = this.$moment
            .utc(this.$moment.duration(checkin.node.oneMile, "seconds").asMilliseconds())
            .format("HH:mm:ss");
        });

        data.userCheckIns.edges.sort((a, b) => {
          return a.node.assessmentDate > b.node.assessmentDate ? -1 : 1;
        });

        let emptyDeltas = {
          weight: 0,
          abdomen: 0,
          chest: 0,
          hip: 0,
          quad: 0,
          oneMile: 0,
          pushUps: 0,
          sitUps: 0,
          burpeeChirpee: 0,
          elbowPlank: 0,
          squat: 0,
        };

        data.userCheckIns.edges.forEach((checkin, index, array) => {
          let assessment = checkin.node;

          if (index < array.length - 1) {
            let next = array[index + 1].node;

            let deltas = {
              weight: ((assessment.weight ?? 0) - (next.weight ?? 0)).toFixed(2),
              abdomen: (assessment.abdomen - next.abdomen).toFixed(2),
              chest: (assessment.chest - next.chest).toFixed(2),
              hip: (assessment.hip - next.hip).toFixed(2),
              quad: (assessment.quad - next.quad).toFixed(2),
              oneMile: assessment.oneMile - next.oneMile,
              pushUps: assessment.pushUps - next.pushUps,
              sitUps: assessment.sitUps - next.sitUps,
              burpeeChirpee: assessment.burpeeChirpee - next.burpeeChirpee,
              elbowPlank: assessment.elbowPlank - next.elbowPlank,
              squat: assessment.squat - next.squat,
            };
            assessment.deltas = deltas;
          } else {
            assessment.deltas = emptyDeltas;
          }
          assessment.showPhotos = false;
        });

        return data.userCheckIns.edges;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1264px) {
  .container {
    max-width: 1400px;
  }
}

.fake-link {
  cursor: pointer;
  padding-left: 5px;
}

.fake-link:hover {
  text-decoration: underline;
}

.scroll-panel {
  display: inline-flex;
  flex-direction: column;
  position: relative;
}
.container {
  position: relative;

  &.full-height {
    height: 100%;
  }
}
.container > .row {
  height: 95%;
}
</style>
